import AuthService from "./api/AuthService";

export const getUserAlertCriteria = async () => {
    try {
        const response = await AuthService.get('/user-alert-criteria');
        return response.data;
    } catch (error) {
        throw new Error("Ocorreu um erro ao requisitar critérios de alerta do usuário");
    }
};

export const getUserAlertCriterion = async (payload) => {
    try {
        const response = await AuthService.get(`/user-alert-criteria/${payload?.criterionId}`);
        
        return response.data;
    } catch (error) {
        throw new Error("Ocorreu um erro ao requisitar critério de alerta do usuário");
    }
};

export const updateUserAlertCriterion = async (payload) => {
    try {
        const response = await AuthService.post(`/user-alert-criteria/${payload?.criterionId}`, payload?.criterionData);
        return response.data;
    } catch (error) {
        throw new Error("Ocorreu um erro ao atualizar critério de alerta do usuário");
    }
};

export default {
    getUserAlertCriteria,
    getUserAlertCriterion,
    updateUserAlertCriterion,
}
